import { address as types } from '../../constants/types'
const address = {
    addresses: [],
    address: {},
    loading: false,
    error: null
}
const reducer = (state = address, action) => {
    const data = action.payload;
    const addresses = state.addresses;
    const indexOfAddress = (types.PUT || types.DELETE) ? addresses.findIndex(obj => obj.id === data?.id) : 0;
    switch (action.type) {
        case types.GET: return { ...state, addresses: data };
        case types.ADDRESS: return { ...state, address: data };
        case types.PUSH: return { ...state, address: data, addresses: [...addresses, data] };
        case types.PUT: {
            addresses[indexOfAddress] = data;
            return { ...state, address: data, addresses: addresses };
        }
        case types.DELETE: {
            addresses.splice(indexOfAddress, 1);
            return { ...state, address: data, addresses: addresses };
        }
        case types.LOADING: return { ...state, loading: !state.loading };
        case types.ERROR: return { ...state, error: data };
        default: return state;
    }
};
export default reducer